<template>
  <div>
    <div class="orderContainer">
      <div class="order w">
        <div class="orderTab" id="orderTab">
          <ul class="clearfix list">
            <li class="triangle-bottomleft active">未付款订单</li>
            <li class="triangle-bottomleft">已付款订单</li>
            <li class="triangle-bottomleft">已完结订单</li>
          </ul>
          <div style="display: block" class="templateBox">
            <noOrder :msg="orderList"></noOrder>
          </div>
          <div class="templateBox">
            <yesOrder :msg="orderList"></yesOrder>
          </div>
          <div class="templateBox"><endOrder :msg="orderList"></endOrder></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noOrder from "./noOrder";
import yesOrder from "./yesOrder";
import endOrder from "./endOrder";
import { getBillList } from "@/api";
export default {
  name: "order",
  components: {
    noOrder,
    yesOrder,
    endOrder,
  },
  data() {
    return {
      orderList: [],
    };
  },
  methods: {
    async getBillLists(flag) {
      let token = window.sessionStorage.getItem("token");
      let usercode = window.sessionStorage.getItem("usercode");
      const res = await getBillList({
        usercode,
        token,
        flag,
        begindate: "",
        enddate: "",
      });
      this.orderList = JSON.parse(res.data);
      // console.log(this.orderList);
    },
    tab(canshu) {
      let vm = this;
      var oBox = document.getElementById(canshu);
      var aLi = oBox.querySelectorAll(".triangle-bottomleft");
      var aDiv = oBox.querySelectorAll(".templateBox");
      aLi.forEach((item) => {
        item.classList.remove("active");
      });
      aLi[this.$store.state.index].classList.add("active");
      aDiv.forEach((item) => {
        item.style.display = "none";
      });
      aDiv[this.$store.state.index].style.display = "block";
      for (let i = 0; i < aLi.length; i++) {
        aLi[i].index = i;
        aLi[i].onclick = function () {
          for (let j = 0; j < aLi.length; j++) {
            aLi[j].classList.remove("active");
          }
          this.classList.add("active");
          for (let k = 0; k < aDiv.length; k++) {
            aDiv[k].style.display = "none";
          }
          aDiv[this.index].style.display = "block";
          vm.getBillLists(this.index + 1);
        };
      }
      this.$store.commit("changeIndexReset");
    },
  },
  mounted() {
    this.tab("orderTab");
    this.getBillLists("1");
  },
};
</script>
<style lang='less' scoped>
.orderContainer {
  font-size: 14px;
  margin-top: 40px;
  .order {
    .orderTab {
      .list {
        padding-left: 20px;
      }
      .templateBox {
        display: none;
        background: #f3f4f6;
      }
      .triangle-bottomleft {
        cursor: pointer;
        width: 215px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        height: 0;
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        border-bottom: 50px solid #e4040b;
        border-right: 50px solid transparent;
        float: left;
      }
      .active {
        border-bottom: 50px solid #f3f4f6 !important;
        color: #e4040b !important;
      }
    }
  }
}
</style>